<template>
  <g>
    <path
      d="M12 11.3902C12 10.7402 11.61 10.1602 11.02 9.91024L5.44001 7.55024C3.96001 9.23024 3.12001 11.2502 2.64001 13.0002H10.39C11.28 13.0002 12 12.2802 12 11.3902Z"
    />
    <path
      d="M21.96 11.2202C21.55 6.81024 17.4 3.73024 12.98 4.02024C10.47 4.18024 8.54 4.96024 7.05 6.06024L11.79 8.07024C13.12 8.64024 13.99 9.94024 13.99 11.3902C13.99 13.3802 12.37 15.0002 10.38 15.0002H2.21C2 16.3102 2 17.2002 2 17.2002V18.0002C2 19.1002 2.9 20.0002 4 20.0002H14C18.67 20.0002 22.41 15.9902 21.96 11.2202Z"
    />
  </g>
</template>
